import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

import { getSelectedInsuranceOffers } from './getSelectedInsuranceOffers'

export function hasInsuranceOffersSelected(
  items: ApiSpecs['/bm/cart']['GET']['response']['cartItems'],
): boolean {
  const selectedInsuranceOffers = getSelectedInsuranceOffers(items)

  return selectedInsuranceOffers.length > 0
}
